import CryptoJS from "crypto-js";

const decryptData = (encryptedData) => {
  try {
    const base64Key="NjU2NTQ1NjQ1MzQzMjM0OA=="
    // Decode Base64 key properly
    const keyString = atob(base64Key); // Decodes base64 string to UTF-8
    const key = CryptoJS.enc.Utf8.parse(keyString); // Converts to WordArray

    // Decrypt the encrypted string
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedString = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return decryptedString || "Decryption returned empty string.";
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};


export default decryptData;